module.exports = __webpack_public_path__ + "img/shakeys_menu_1.1dbb9efc.jpg";